<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="400" persistent>
      <v-card>
        <v-app-bar dense color="warning">
          <v-toolbar-title class="h6 white--text">
            <v-icon left class="mr-2" color="white">{{ warningIcon }}</v-icon
            >{{ title }}
          </v-toolbar-title>
        </v-app-bar>
        <v-container>
          <v-card-text>
            {{ text }}
            <template v-if="allowSuppression">
              <v-checkbox @click="toggleSuppress()" :value="suppress" :ripple="false" label="Suppress this warning?">
              </v-checkbox>
            </template>
          </v-card-text>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text class="mr-2" @click="respond(false)"> No </v-btn>
          <v-btn color="primary" text @click="respond(true)"> Yes </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { WARNING_ICON } from './constants'

export default {
  name: 'WarningDialog',
  props: {
    title: String,
    text: String,
    allowSuppression: Boolean
  },
  data() {
    return {
      dialog: false,
      warningIcon: WARNING_ICON,
      suppress: false,
      resolve: null
    }
  },
  methods: {
    show() {
      this.suppress = false
      this.dialog = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    toggleSuppress() {
      this.suppress = !this.suppress
    },
    respond(val) {
      this.resolve({ result: val, suppress: this.suppress })
      this.dialog = false
    }
  }
}
</script>
